<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.expenseItem')" prop="costItem">
            <el-cascader style="width:100%" ref="cascader1" v-model="costItem" :options="costItemList" @change="costItemChange" :placeholder="$t('billingPage.expenseItem')" filterable clearable :show-all-levels="false" :props="{ expandTrigger: 'hover' }"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.expenseCategory')" prop="costCategory">
            <el-cascader style="width:100%" ref="cascader2" v-model="costCategory" :options="CategoryList" @change="costCategoryChange" :placeholder="$t('billingPage.expenseCategory')" filterable clearable :show-all-levels="false" :props="{ expandTrigger: 'hover' }"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.expensePeriod')">
            <BjDateRangePicker :tipShow="true" v-model="queryParamsTime_expensePeriod" :placeholder="$t('billingPage.expensePeriod')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd()">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'startTime'">
                <span>{{ scope.row.startTime ? `${scope.row.startTimeCopy} - ${scope.row.endTimeCopy}` : '' }}</span>
              </template>
              <template v-else-if="col.prop == 'amount'">
                <span>{{ $number2money(scope.row[col.prop]) }}</span>
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <!-- <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button> -->
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :before-close="handleClose">
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <el-form-item :label="$t('billingPage.expenseItem')" prop="costItem">
          <el-cascader style="width:100%" ref="cascader3" v-model="costItemForm" :options="costItemList" @change="costItemFormChange" :placeholder="$t('billingPage.expenseItem')" filterable clearable :show-all-levels="false" :props="{ expandTrigger: 'hover' }"></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('billingPage.expenseCategory')" prop="costCategory">
          <el-cascader style="width:100%" ref="cascader4" v-model="costCategoryForm" :options="CategoryList" @change="costCategoryFormChange" :placeholder="$t('billingPage.expenseCategory')" filterable clearable :show-all-levels="false" :props="{ expandTrigger: 'hover' }"></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('billingPage.expensePeriod')" prop="expensePeriod">
          <BjDateRangePicker :tipShow="true" v-model="queryParamsTime_form_expensePeriod" :placeholder="$t('billingPage.expensePeriod')" :clearable="false"/>
        </el-form-item>
        <el-form-item :label="$t('settingOrderMoney.table.amount')" prop="amount">
          <BjInputMoney v-model="form.amount" :not-auto-zero="true" :placeholder="$t('settingOrderMoney.table.amount')"></BjInputMoney>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { funConfigApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import moment from 'moment';
const getDefaultForm = () => {
  return {
    costItem: null,
    costCategory: null,
    startTime: null,
    endTime: null,
    amount: null,
  };
};

export default {
  name: 'BusinessBillingCostExpenditureStatistics',
  components: {},
  mixins: [pageMiXin],
  data() {
    const validateCostItem = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.costItem) {
          callback(new Error(this.$t('chooseText')));
        } else{
          callback();
        }
      }, 300)
    };
    const validateCostCategory = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.costCategory) {
          callback(new Error(this.$t('chooseText')));
        } else{
          callback();
        }
      }, 300)
    };
    const validateTime = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.startTime || !this.form.endTime) {
          callback(new Error(this.$t('chooseText')));
        } else{
          callback();
        }
      }, 300)
    };
    return {
      colSpan: 4,
      selection: true,
      queryApi: funConfigApi.getCostExpenditureList,
      queryParamsTime_expensePeriod: [],
      queryParamsTime_form_expensePeriod: [],
      queryParams: {
        costItem: '',
        startTime: '',
        endTime: '',
      },
      // 下拉搜索列表
      costItemList: [],
      // 下拉搜索列表
      CategoryList: [],
      costItem:null,
      costCategory:null,
      costItemForm:null,
      costCategoryForm:null,
      labelList: [
        { label: this.$t('billingPage.expenseItem'), prop: 'costItem', isCheck: true, disabled: false },
        { label: this.$t('billingPage.expenseCategory'), prop: 'costCategory', isCheck: true, disabled: false },
        { label: this.$t('billingPage.expensePeriod'), prop: 'startTime', isCheck: true, disabled: false },
        { label: this.$t('settingOrderMoney.table.amount'), prop: 'amount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.createdAt'), prop: 'createBy', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:160 },
      ],

      // 弹窗相关数据
      dialogTitle:null,
      dialogFormVisible: false,
      form: getDefaultForm(),
      rules: {
        costItem: [{ required: true, validator: validateCostItem, trigger: 'change' }],
        costCategory: [{ required: true, validator: validateCostCategory, trigger: 'change' }],
        expensePeriod: [{ required: true, validator: validateTime, trigger: 'change' }],
        amount: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getCostExpendit();
  },
  watch: {
    queryParamsTime_expensePeriod(v) {
      this.queryParams.startTime = (v || [])[0];
      this.queryParams.endTime = (v || [])[1];
    },
    queryParamsTime_form_expensePeriod(v) {
      this.form.startTime = (v || [])[0];
      this.form.endTime = (v || [])[1];
    },
  },
  methods: {
    costItemChange(){
      setTimeout(() => {
        this.queryParams.costItem = this.$refs.cascader1.getCheckedNodes()[0]?.label
        this.handleQuery()
      }, 300);
    },
    costCategoryChange(){
      setTimeout(() => {
        this.queryParams.costCategory = this.$refs.cascader2.getCheckedNodes()[0]?.label
        this.handleQuery()
      }, 300);
    },
    costItemFormChange(){
      setTimeout(() => {
        this.form.costItem = this.$refs.cascader3.getCheckedNodes()[0]?.label
      }, 300);
    },
    costCategoryFormChange(){
      setTimeout(() => {
        this.form.costCategory = this.$refs.cascader4.getCheckedNodes()[0]?.label
      }, 300);
    },
    // 过滤列表时间
    afterFetchOriginalData(res) {
      const arr = res.content && res.content.map(item => {
        return {
          ...item,
          startTimeCopy : moment(item.startTime).format('DD/MM/YYYY'),
          endTimeCopy   : moment(item.endTime).format('DD/MM/YYYY'),
        }
      });
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = arr;
      });
    },
    // 获取支出类别下拉数据
    getCostExpendit() {
      funConfigApi.getCostExpenditureItemPull().then(res => {
        this.costItemList = res
      });
      funConfigApi.getCostExpenditureCategoryPull().then(res => {
        this.CategoryList = res
      });
    },
    onAdd(){
      this.dialogTitle = this.$t('addText')
      this.dialogFormVisible = true;
    },
    // onEdit(row){
    //   this.dialogTitle = this.$t('editText')
    //   this.form = JSON.parse(JSON.stringify(row));
    //   this.form.amount = this.$number2money(this.form.amount),
    //   this.queryParamsTime_form_expensePeriod = [this.form.startTime,this.form.endTime]
    //   this.dialogFormVisible = true;
    // },
    // 保存弹窗数据 并 关闭编辑弹窗
    saveAmount() {
      console.log(this.form);
      this.$refs.form.validate(valid => {
        if (valid) {
          // 原任务需求判断：不可以输入0
          // 李亚辉提Bug：原逻辑不可以为‘0.00’去掉，现在可以输入0
          // if(this.form.amount == '0.00'){return this.msgError(`${this.$t('inputText')} ${this.$t('settingOrderMoney.table.amount')}`);}
          if(!this.form.id){
            funConfigApi.addCostExpenditureList(this.form).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose()
                this.reFresh();
              }
            });
          }else{
            funConfigApi.editCostExpenditureList(this.form).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose()
                this.reFresh();
              }
            });
          }
        }
      })
    },
    /** 关闭弹窗 清空数据 */
    handleClose() {
      this.form = getDefaultForm();
      this.queryParamsTime_form_expensePeriod = []
      this.costItemForm = null;
      this.costCategoryForm = null;
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
    },
    // 删除按钮
    onDel(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          funConfigApi.delCostExpenditureList({costId: row.id}).then(res => {
            if(!res.failed){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => { });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_expensePeriod = [];

      this.queryParams.costItem = null;
      this.queryParams.costCategory = null;

      this.costItem = null;
      this.costCategory = null;
      
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
